import { put, call, select, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../actions/actionTypes';
import { saveWidgetsFailure, WidgetActions } from '../actions/widgetActions';
import { updateUserWidgets } from '../apis/userWidgets';
import { getWidgetsInCurrentState, getWindowWidthInCurrentState, saveLayoutsToDatabase } from '../utilities/widgetHelper'
import { UserWidget } from '../constants/online.homepagegateway.api';

export function* saveLayoutsToDB(action: WidgetActions) {
    try {
        const widgets: UserWidget[] = yield select(getWidgetsInCurrentState);
        const windowWidth: number = yield select(getWindowWidthInCurrentState);

        const modifiedWidgets = saveLayoutsToDatabase(widgets, action.payload, windowWidth);
        yield call(updateUserWidgets, {widgetData: modifiedWidgets});
    }
    catch (error) {
        yield put(saveWidgetsFailure(error));
    }
}

export function* watchSaveWidgetsLayoutToDb() {
    yield takeLatest(ActionTypes.SAVE_WIDGETS_LAYOUT_TO_DB, saveLayoutsToDB);
}